$(document).ready(function ($) {
  $('input[data-error-message]').bind('input', function(event) {
    let elem = event.target;

    elem.setCustomValidity($(elem).attr('data-error-message'));
  });
  $('.btn-show-all-accounts').on('click', function(e){
    e.preventDefault();
    $('.signup-shares-hidden').slideDown();
    $(this).hide();
  });

  function handleAccountantChange() {
    if ($('#accountant').val() === 'firm') {
      $('#accountant-splash').fadeIn();
      $('.grid-int').fadeOut();
    } else {
      $('#accountant-splash').fadeOut();
      $('.grid-int').fadeIn();
    }
  }

  function handleFormChange() {
    if ($('#name-temp').val() && $('#password-temp').val() && $('#accountant').val()) {
      $('#btnNext').removeAttr('disabled');
    } else {
      $('#btnNext').attr('disabled','disabled');
    }
  }

  function handleFormMarketingValChange(isFirmPage) {
    if ($('#team').val() && $('#country').val()) {
      isFirmPage ? $('#finish-button-firms-click').removeAttr('disabled') : $('#finish-button-click').removeAttr('disabled');
    } else {
      isFirmPage ? $('#finish-button-firms-click').attr('disabled','disabled') : $('#finish-button-click').attr('disabled','disabled');
    }
  }


  $('.accountant-list li').on('click', function(e){
    $('.accountant-list li').removeClass('selected');
    $(this).addClass('selected');
    $('#accountant').val($(this).data('accountant'));
    $('input[name="input-acct"]')
      .prop('checked', false)
      .val($(this).data('accountant'));
    $(this).find('input[name="input-acct"]')
      .prop('checked', true);

    handleAccountantChange();
    handleFormChange();
  });

  $('#accountant').on('change', function(e) {
    e.preventDefault();
    handleAccountantChange();
  });


  $('#register-form-temp').on('keyup change', function() {
    handleFormChange()
  });
  
  $('#register-form').on('keyup change', function() {
    handleFormMarketingValChange(true)
  });

  $('#step-teamname').on('keyup change', function() {
    handleFormMarketingValChange(false)
  });

  $('#register-form-temp').on('submit', function(e) {
    e.preventDefault();

    let firmsPresent = $("#register-top").data('firmspresent') === 'true';
    let numTeams = parseInt($("#register-top").data('numteams'));


    $('input[name="name"]').val($('#name-temp').val());
    $('input[name="password"]').val($('#password-temp').val());
    $('input[name="isFirm"]').val($('#accountant').val() === 'firm');

    let accountant = $('#accountant').val();
    let businessType = accountant === 'firm' ? 'practice' : 'business';
    $('.step-teamname-type').text(businessType);
    $('#step-password').hide();
    $('#step-teamname').show();

    console.log({firmsPresent, numTeams, accountant});

    if (accountant === 'business') {
      if (numTeams === 0) {
        $('#team-name-container').show();
        $('#team-name-skip-container').hide();
        $('#step-teamname-invite').show();
      } else {
        $('#team-name-container').hide();
        $('#team-name-skip-container').show();
      }
    } else {
      $('#team-name-container').show();
      $('#team-name-skip-container').hide();
      $('#step-teamname-invite').hide();
    }

    if (numTeams && accountant === 'business') {
      $('#finish-button-click').removeAttr('disabled');
    } else {
      $('#finish-button-click').attr('disabled','disabled');
    }

  });

  $('#btnPrev').on('click', function(e) {
    e.preventDefault();
    $('#step-teamname').hide();
    $('#step-password').show();
  });


  $('#name-temp').on('change', function() {
    $('#step-teamname-name').text($(this).val());
  })


});
